export class ResetPasswordModel {
    Id: string = "";
    Code: string = "";
    Password: string = "";
    ConfirmPassword: string = "";
}


// WEBPACK FOOTER //
// ./app/objects/users/resetPasswordModel.ts